import state from "./AccessLogState";
import {getData, getList, getPage} from "@/api/baseApi";
import {Message} from 'element-ui'
import {setDateRange} from "@/utils/common";
import axios from '@/config/httpConfig'

/**
 * 访问日志表数据提供者
 *
 * @author System
 * @since 2026-03-09
 */
export default {
    namespaced: true,
    state: state,
    getters: {},
    mutations: {
        setDialogVisible(state, visible) {
            state.formInfo.dialogVisible = visible;
        },
        setStatistics(state, data) {
            state.statistics = data;
        },
    },
    actions: {
        /** 处理表格查询 */
        handleTableSearch({state}) {
            state.queryParams.currPage = 1;
            let param = state.queryParams;
            for (let key in state.dateRange) {
                param = setDateRange(param, state.dateRange[key], key);
            }
            getPage("system", "accessLog", param).then(res => {
                if (res.code === 200) {
                    state.tableData = res.data.list;
                    state.totalCount = res.data.totalCount;
                }
            })
        },
        /** 获取统计数据 */
        getStatistics({commit}) {
            getData("system","accessLog","statistics").then(res => {
                if (res.code === 200) {
                    commit("setStatistics", res.data);
                }
            }).catch(() => {
            });
        },
        /** 获取详情 */
        handleViewDetail({commit}, data) {
            commit('setDialogVisible', true);
            state.formInfo.editData = data;
        },
    },
    modules: {}
}
